import { letterheadHTML, officialSignatureHTML, withDept } from "../components/Letterhead";

const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
const ONES = ["", "واحد", "اثنان", "ثلاثة", "أربعة", "خمسة", "ستة", "سبعة", "ثمانية", "تسعة", "عشرة", "أحد عشر", "اثنا عشر", "ثلاثة عشر", "أربعة عشر", "خمسة عشر", "ستة عشر", "سبعة عشر", "ثمانية عشر", "تسعة عشر"];
const TENS = ["", "", "عشرون", "ثلاثون", "أربعون", "خمسون", "ستون", "سبعون", "ثمانون", "تسعون"];
const HUND = ["", "مائة", "مائتان", "ثلاثمائة", "أربعمائة", "خمسمائة", "ستمائة", "سبعمائة", "ثمانمائة", "تسعمائة"];
const below1000 = (n) => {
  const h = Math.floor(n / 100), r = n % 100, parts = [];
  if (h) parts.push(HUND[h]);
  if (r) parts.push(r < 20 ? ONES[r] : (r % 10 ? `${ONES[r % 10]} و${TENS[Math.floor(r / 10)]}` : TENS[Math.floor(r / 10)]));
  return parts.join(" و");
};
const scale = (n, one, two, few, many) => (n === 1 ? one : n === 2 ? two : n <= 10 ? `${below1000(n)} ${few}` : `${below1000(n)} ${many}`);
export const tafqeet = (amount) => {
  const v = Math.round(Math.abs(Number(amount) || 0) * 100);
  let int = Math.floor(v / 100); const hal = v % 100;
  if (!int && !hal) return "صفر ريال";
  const parts = [];
  const mil = Math.floor(int / 1e6); int %= 1e6;
  const th = Math.floor(int / 1000); const rest = int % 1000;
  if (mil) parts.push(scale(mil, "مليون", "مليونان", "ملايين", "مليون"));
  if (th) parts.push(scale(th, "ألف", "ألفان", "آلاف", "ألف"));
  if (rest) parts.push(below1000(rest));
  let out = parts.length ? `${parts.join(" و")} ريال` : "";
  if (hal) out += `${out ? " و" : ""}${below1000(hal)} هللة`;
  return `${out} فقط لا غير`;
};

const money = (n) => Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const page = (r, fields, company, month) => {
  const v = r.values || {};
  const deds = fields.filter((f) => f.group === "deduct" && Number(v[f.key]));
  const adds = fields.filter((f) => ["base", "allow"].includes(f.group) && f.key !== "freelance_revenue" && Number(v[f.key]));
  const line = (l, a, neg) => `<tr><td>${esc(l)}</td><td class="n">${neg ? "−" : ""}${money(a)}</td></tr>`;
  return `<section class="pg">
    ${letterheadHTML(company || {})}
    <h1>فاتورة مستحقات شهرية</h1><p class="sub">Monthly Freelance Payment Invoice</p>
    <table class="meta"><tr><td>رقم الفاتورة: <b>${esc(r.invoice_number || "مسودة — غير مرقّمة")}</b></td><td>عن شهر: <b>${esc(month)}</b></td></tr>
      <tr><td>اسم المندوب: <b>${esc(r.employee_name || r.name)}</b></td><td>رقم الإقامة: <b>${esc(r.iqama_number || "—")}</b></td></tr>
      <tr><td>رقم الكابتن: <b>${esc(r.rider_id || "—")}</b></td><td>نوع العقد: <b>${esc(r.contract_type || "فري لانسر")}</b>${r.platform ? ` · التطبيق: <b>${esc(r.platform)}</b>` : ""}</td></tr>
      <tr><td>عدد الطلبات المنجزة: <b>${esc(r.completed_orders ?? r.orders ?? 0)}</b></td><td>تاريخ الإصدار: <b>${new Date().toISOString().slice(0, 10)}</b></td></tr></table>
    <table class="items"><thead><tr><th>البند</th><th class="n">المبلغ (ر.س)</th></tr></thead><tbody>
      ${line("إجمالي الإيراد (بدون ضريبة)", v.freelance_revenue)}
      ${adds.map((f) => line(f.label, v[f.key])).join("")}
      ${Number(v.company_commission) ? line("حصة الشركة", v.company_commission, true) : ""}
      ${deds.filter((f) => f.key !== "company_commission").map((f) => line(f.label, v[f.key], true)).join("")}
    </tbody><tfoot><tr><td>الصافي المستحق للمندوب</td><td class="n">${money(v.net_salary)}</td></tr></tfoot></table>
    <p class="words">المبلغ كتابةً: <b>${esc(tafqeet(v.net_salary))}</b></p>
    ${r.cancelled ? `<p class="void">فاتورة ملغاة — ${esc(r.cancel_reason || "")}</p>` : ""}
    <p class="note">هذه الفاتورة مستحقات عمل حر (فري لانسر) وليست مسيّر راتب، ولا تشمل ضريبة القيمة المضافة.</p>
    <div class="sig"><div><p>توقيع المندوب (المستفيد):</p><div class="ln"></div><p class="s">${esc(r.employee_name || r.name)}</p></div><div>${officialSignatureHTML(withDept(company || {}, "finance"))}</div></div>
  </section>`;
};

export const printFreelanceInvoices = (rows, fields, company, month, w = window.open("", "_blank")) => {
  if (!w) return false;
  w.document.open();
  w.document.write(`<!doctype html><html dir="rtl" lang="ar"><head><meta charset="utf-8"><title>فواتير مستحقات ${esc(month)}</title><style>
    @page{size:A4;margin:14mm}body{font-family:Tahoma,Arial;color:#0f172a;margin:0}
    .pg{page-break-after:always;padding:4px}.pg:last-child{page-break-after:auto}
    h1{text-align:center;color:#1e40af;margin:14px 0 0;font-size:22px}.sub{text-align:center;color:#64748b;margin:2px 0 14px;font-size:12px}
    table{width:100%;border-collapse:collapse;font-size:13px}.meta td{padding:6px;border:1px solid #e2e8f0;width:50%}
    .items{margin-top:14px}.items th{background:#1e40af;color:#fff;padding:8px;text-align:right}.items td{padding:8px;border-bottom:1px solid #e2e8f0}
    .n{text-align:left;direction:ltr;font-variant-numeric:tabular-nums}tfoot td{font-weight:700;font-size:15px;background:#eff6ff;padding:10px;border-top:2px solid #1e40af}
    .words{margin-top:12px;padding:10px;background:#f8fafc;border-radius:8px;font-size:13px}.note{color:#64748b;font-size:11px}
    .void{color:#b91c1c;border:2px solid #b91c1c;padding:8px;text-align:center;font-weight:700;border-radius:8px}.sig{display:flex;justify-content:space-between;gap:30px;margin-top:40px;font-size:13px}.sig>div{flex:1}.ln{border-bottom:1px solid #94a3b8;height:50px}.s{color:#64748b}
  </style></head><body>${rows.map((r) => page(r, fields, company, month)).join("")}<script>setTimeout(()=>print(),400)</script></body></html>`);
  w.document.close();
  return true;
};

// Opens the print window synchronously (popup-safe), assigns register numbers, then prints.
export const issueAndPrintFreelance = async (rows, fields, company, month, issue) => {
  const w = window.open("", "_blank");
  if (!w) return false;
  w.document.write('<p dir="rtl" style="font-family:Tahoma;padding:20px">جاري ترقيم الفواتير…</p>');
  try {
    const { numbers } = await issue(rows.map((r) => r.id));
    return printFreelanceInvoices(rows.map((r) => ({ ...r, invoice_number: numbers[r.id] })), fields, company, month, w);
  } catch (e) { w.close(); throw e; }
};
